import { sharedMemoryCache } from "src-next/shared/cache/createMemoryCache";

import type { MessageTemplate } from "../types";
import { messageTemplatesService } from "./messageTemplatesService";

/**
 * A chave inclui o WABA porque a lista da Meta é por conta.
 * WABA vazio não entra: buscar com o default enquanto o endpoint real
 * ainda não resolveu gravaria o conjunto errado e seria reaproveitado depois.
 */
export function messageTemplatesCacheKey(wabaId: string): string | null {
  const trimmed = wabaId.trim();
  if (!trimmed) return null;
  return `crm:message-templates:${trimmed}`;
}

/** Leitura compartilhada (hook e `automationService`) da mesma listagem. */
export function getOrFetchMessageTemplates(
  wabaId: string,
  options?: { force?: boolean },
): Promise<MessageTemplate[]> {
  const cacheKey = messageTemplatesCacheKey(wabaId);
  if (!cacheKey) return Promise.resolve([]);

  return sharedMemoryCache.getOrFetch(
    cacheKey,
    () =>
      messageTemplatesService.list({
        whatsappBusinessAccountId: wabaId.trim(),
      }),
    options,
  );
}
